var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_28415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.33464V3.33464C11.3333 3.15782 11.2631 2.98826 11.1381 2.86323C11.013 2.73821 10.8435 2.66797 10.6667 2.66797H4C3.64638 2.66797 3.30724 2.80844 3.05719 3.05849C2.80714 3.30854 2.66667 3.64768 2.66667 4.0013M2.66667 4.0013C2.66667 4.35492 2.80714 4.69406 3.05719 4.94411C3.30724 5.19416 3.64638 5.33464 4 5.33464H12C12.1768 5.33464 12.3464 5.40487 12.4714 5.5299C12.5964 5.65492 12.6667 5.82449 12.6667 6.0013V8.0013M2.66667 4.0013V12.0013C2.66667 12.3549 2.80714 12.6941 3.05719 12.9441C3.30724 13.1942 3.64638 13.3346 4 13.3346H12C12.1768 13.3346 12.3464 13.2644 12.4714 13.1394C12.5964 13.0143 12.6667 12.8448 12.6667 12.668V10.668",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8V10.6667H10.6667C10.313 10.6667 9.97391 10.5262 9.72386 10.2761C9.47381 10.0261 9.33333 9.68696 9.33333 9.33333C9.33333 8.97971 9.47381 8.64057 9.72386 8.39052C9.97391 8.14048 10.313 8 10.6667 8H13.3333Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_28415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.b83dad7fda48e95d64b8a0c8c7c6a332.svg";
export { ForwardRef as ReactComponent };